import React, { Component } from 'react';
import { Link } from 'react-router';

require('styles/Opportunity.scss');

class OpportunityComponent extends Component{
  render() {
    let {opportunity} = this.props;
    let imageUrl = `${opportunity.imageUrl}!list`;
    return (
      <div className='opportunity-component'>
        <Link to={`/opportunity/${opportunity._id}`} >
          <span className='title'>{opportunity.title}</span>
          <img className='img-responsive image center-block' src={imageUrl} />
          {!opportunity.hasConfirmed?<div className='price'>¥{opportunity.price}</div>:''}
          {opportunity.hasConfirmed?<div className='close'>已截止</div>:''}
        </Link>
      </div>
    );
  }
}

export default OpportunityComponent;


// WEBPACK FOOTER //
// ./src/components/OpportunityComponent.js